import { render, staticRenderFns } from "./RoutingPrefixList.vue?vue&type=template&id=45ecf8d3&"
import script from "./RoutingPrefixList.vue?vue&type=script&lang=js&"
export * from "./RoutingPrefixList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports